import { HeatMap } from "../../components/HeatMap";


const RelatedHeatMap = ({ subHeatMapData, boxShadow, setboxShadow, handleHeatMapClick }: any) => {
    if (subHeatMapData.length === 0) return null; 

    return (
        <HeatMap 
            heatMapData={subHeatMapData}  
            boxShadow={boxShadow} 
            setboxShadow={setboxShadow} 
            handleHeatMapClick={handleHeatMapClick} 
        />
    );
};
export default RelatedHeatMap;
